import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Table, Input, Card, Modal } from 'antd'
import AdminHeader from '../CommonComponent/AdminHeader'
import Footer from '../CommonComponent/Footer'
import { EyeOutlined } from '@ant-design/icons'
import { IMG_BASE_URL, InactiveRegList } from '../../AllAPI/AdminAPI'

const RegPendingList = () => {
  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(false)

  const [viewModal, setViewModal] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  useEffect(() => {
    fetchPendingList()
  }, [])

  const fetchPendingList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(InactiveRegList)
      setData(res.data)
    } catch (err) {
      console.log(err)
    }
    setLoading(false)
  }

  // ===== Search Filter =====
  const filteredData = data.filter((item) =>
    Object.values(item).join(' ').toLowerCase().includes(search.toLowerCase()),
  )

  // ACTION: OPEN MODAL
  const handleView = (record) => {
    setSelectedRecord(record)
    setViewModal(true)
  }

  // ===== Table Columns =====
  // TABLE COLUMNS
  const columns = [
    {
      title: 'Sr No.',
      dataIndex: 'sr',
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
      width: 80,
    },
    {
      title: 'Student Name',
      render: (_, record) =>
        `${record.fname || ''} ${record.mname || ''} ${
          record.lname || ''
        }`.trim(),
    },
    {
      title: 'Mobile',
      dataIndex: 'mobile',
      width: 130,
    },
    {
      title: 'Email',
      dataIndex: 'email',
    },
  ]

  return (
    <div className="bg-gray-100 min-h-screen">
      <AdminHeader />

      <div className="row m-0 p-md-5 pt-0">
        <div className="col-12 col-md-2"></div>

        <div className="col-12 col-md-8 pb-5">
          {/* Header */}
          <header className="reg-header pt-3">
            <h3 className="reg-title pt-1 pt-md-0"> Reg. Pending List </h3>
          </header>

          {/* Search Bar */}
          <div className="row m-0 p-0" style={{ marginTop: '10px' }}>
            <div className="col-12 col-md-8"></div>
            <div className="col-12 col-md-4">
              <Input
                placeholder="Search here..."
                size="large"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  borderRadius: '8px',
                  border: '1px solid #ccc',
                }}
              />
            </div>
          </div>

          {/* Table */}
          <div style={{ marginTop: '10px' }}>
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredData}
              rowKey="id"
              //  pagination={{
              //   pageSize: pageSize,
              //   current: currentPage,
              //   onChange: (page) => setCurrentPage(page),
              // }}
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
                onChange: (page) => {
                  setCurrentPage(page)
                },
                onShowSizeChange: (current, size) => {
                  setPageSize(size)
                  setCurrentPage(1) // reset to first page
                },
              }}
              bordered={true}
              className="custom-ant-table shadow border"
              style={{ background: 'white', borderRadius: '10px' }}
              scroll={{ x: 'max-content' }}
            />
          </div>

          {/* VIEW MODAL */}
          <Modal
            open={viewModal}
            onCancel={() => setViewModal(false)}
            title="Student Details"
            footer={null}
            width={800}
            className="custom-modal"
          >
            {selectedRecord && (
              <div className="p-2">
                {/* --- FORM GRID --- */}
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '15px',
                  }}
                >
                  <div>
                    <label className="font-semibold">Full Name</label>
                    <Input
                      value={`${selectedRecord.fname} ${selectedRecord.mname} ${selectedRecord.lname}`}
                      readOnly
                    />
                  </div>

                  <div>
                    <label className="font-semibold">Email</label>
                    <Input value={selectedRecord.email} readOnly />
                  </div>

                  <div>
                    <label className="font-semibold">Mobile</label>
                    <Input value={selectedRecord.mobile} readOnly />
                  </div>

                  <div>
                    <label className="font-semibold">Gender</label>
                    <Input
                      value={selectedRecord.gender === 1 ? 'Male' : 'Female'}
                      readOnly
                    />
                  </div>

                  <div>
                    <label className="font-semibold">Date of Birth</label>
                    <Input value={selectedRecord.date_of_birth} readOnly />
                  </div>

                  <div>
                    <label className="font-semibold">Blood Group</label>
                    <Input value={selectedRecord.blood_group} readOnly />
                  </div>

                  <div>
                    <label className="font-semibold">Education</label>
                    <Input value={selectedRecord.education} readOnly />
                  </div>

                  <div>
                    <label className="font-semibold">Occupation</label>
                    <Input value={selectedRecord.occupation} readOnly />
                  </div>

                  <div>
                    <label className="font-semibold">Payment Amount</label>
                    <Input value={selectedRecord.payment_amount} readOnly />
                  </div>

                  <div>
                    <label className="font-semibold">Payment Status</label>
                    <Input
                      value={selectedRecord.payment_status ? 'Paid' : 'Pending'}
                      readOnly
                    />
                  </div>

                  {/* --- PROFILE PHOTO --- */}
                  <div style={{ marginTop: '20px' }}>
                    <label className="font-semibold">Profile Photo</label>
                    <div
                      style={{
                        border: '1px solid #ddd',
                        width: '240px',
                        // height: '240px',
                        borderRadius: '8px',
                      }}
                    >
                      <img
                        src={`${IMG_BASE_URL}${selectedRecord.s_pic}`}
                        alt="Profile"
                        style={{
                          width: '240px',
                          // height: '240px',
                          borderRadius: '8px',
                          objectFit: 'fill',
                        }}
                      />
                    </div>
                  </div>

                  {/* --- PAYMENT SCREENSHOT --- */}
                  <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                    <label className="font-semibold">Payment Screenshot</label>
                    <div
                      style={{
                        border: '1px solid #ddd',
                        width: '260px',
                        borderRadius: '8px',
                      }}
                    >
                      <img
                        src={`${IMG_BASE_URL}${selectedRecord.payment_screenshot}`}
                        alt="Payment Screenshot"
                        style={{
                          width: '260px',
                          borderRadius: '8px',
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Modal>
        </div>

        <div className="col-12 col-md-2"></div>
      </div>

      <Footer />
    </div>
  )
}

export default RegPendingList
